module.exports = __webpack_public_path__ + "img/m2g_title.e4655d42.png";